module.exports = __webpack_public_path__ + "static/media/onda-violeta.87a30111.png";